import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import type { Dispatch } from "redux";
import { Box, Button } from "@mui/material";
import PagesList from "../../components/PagesList";
import { openImportPageDialog } from "../../actions/pageActions/actions";
import {
  getPagesListLoading,
} from "../../selectors/page";
import type { State } from "../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/PagesContainer.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  loading: getPagesListLoading(state),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    openImportPage: openImportPageDialog,
  }, dispatch),
});

function PagesContainer({
  openImportPage,
}: Props) {
  return (
    <Box mt={3} mb={3}>
      <Box display="flex" justifyContent="flex-end" mb={1}>
        <Button variant="outlined" onClick={openImportPage} data-testid="import-csv-button">Import CSV</Button>
      </Box>
      <PagesList />
    </Box>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PagesContainer);
